import React from 'react'

export default function DashMastery() {
  return (
    <div className='bg-white h-full text-black'>
        <h1>Mastery/Skills Tab</h1>
    </div>
  )
}
